<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1C7l2pq/tc-custom/9781429929004.jpg?1728726136813" alt="This image is the cover for the book Hungry Girl 1-2-3"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hungry Girl 1-2-3
      </h1>
      <p class="bookDescription body article font2">
        <p>Are you HUNGRY? The number-one <i>New York Times</i> bestselling phenomenon is BACK---with even more yum-a-licious guilt-free recipes. This time, the EASIEST ones on the planet!<br/><br/>Hungry Girl's recipes aren't just delicious, they're SUPER-SIMPLE, too. <i>Hungry Girl 1-2-3</i> will help you make the world's most delicious guilt-free appetizers, meals, snacks, desserts, etc., with practically no effort whatsoever! There are loads of crock-pot recipes, microwavable meals, HG's famous "foil packs," and more. Some are such a cinch, you won't even have to turn on the oven or stove! Really.<br/><br/>With more than 200 recipes and two-ingredient "couples" to choose from, you'll never be hungry again! Get ready to chew on:<br/><br/>Crazy Pineapple Salmon Teriyaki (347 calories)<br/><br/>Mom-Style Creamy Chicken 'n Veggies (307 calories)<br/><br/>Queen-of-the-Castle Sliders (254 calories)<br/><br/>Caramel Swirl Cream Puffs (121 calories)<br/><br/>Corndog Millionaire Muffins (160 calories)<br/><br/>Chili Cheese Dog Nachos (218 calories)<br/><br/>Turkey &amp; Veggie Meatloaf Minis (142 calories)<br/><br/>Planet Hungrywood Sweet &amp; Cap'n Crunchy Chicken (234 calories)<br/><br/>Shrimp &amp; Grits . . . for Hungry Chicks! (380 calories)<br/><br/>Cannoli-Stuffed French Toast Nuggets (228 calories)</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lisa Lillien
      </h2>
      
      <p class="authorDescription body article"><P><B>Lisa Lillien</B> is not a nutritionist, she's just hungry. She's the founder of www.hungry-girl.com, the daily email service providing approximately one million fans with guilt-free recipes, food and product reviews, dieting news, shockers and more. She also writes weekly columns for WeightWatchers.com and Yahoo!, and regularly contributes to <I>Redbook</I> magazine. She has appeared on TV shows like <I>Rachael Ray</I> and <I>Extra</I>, and now has her own show on the Cooking Channel. Her Hungry Girl cookbooks are <I>New York Times</I> bestsellers. She lives in Los Angeles, California.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Amazon
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?10538024